
import Enumerable from "linq";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { DomainRegistry } from "../../../domain";
import { Department, DepartmentGroup } from "../../../domain/department";

@Component({
})
export default class AuthenticationMixin extends Mixins() {
  @Prop()
  userCode: string;

  @Prop()
  orderUserCode: string;

  @Prop()
  attendingUserCode: string;

  @Prop()
  doAuthentication: (userId: string, password: string) => Promise<void>;

  data(): any {
    return {
      id: !this.userCode
        ? ""
        : this.userCode,
      orderUserId: !this.orderUserCode
        ? null
        : this.orderUserCode,
      attendingUserId: !this.attendingUserCode
        ? null
        : this.attendingUserCode,
      doAuthenticate: !this.doAuthentication
        ? null
        : this.doAuthentication,
      password: "",
      isAuthenticating: false,
      isAuthenticatingAutomatically: false,
      isAuthenticatedAutomatically: false,
    };
  }
  id: string;
  orderUserId: string;
  attendingUserId: string;
  doAuthenticate: (userId: string, password: string) => Promise<void>;
  password: string;
  isAuthenticating: boolean;
  isAuthenticatingAutomatically: boolean;
  isAuthenticatedAutomatically: boolean;

  async login(id: string, password: string, departmentId: string, hostName: string, departmentGroupId: string, referenceableDepartmentGroupCodes: string[]): Promise<void> {
    try {
      const service = DomainRegistry.authentication.getAuthenticationService();
      this.isAuthenticating = true;
      await service.login(id, password, departmentId, hostName, departmentGroupId, referenceableDepartmentGroupCodes);
      // TODO: できればAuthのAPIにまとめたい
      await this.setUserSelection();
      this.isAuthenticating = false;
    } catch (e) {
      this.isAuthenticating = false;
      throw e;
    }
  }

  async loginAutomatically(id: string, departmentId: string, hostName: string, orderUserId: string, attendingUserId: string, departmentGroupCode: string, referenceableDepartmentGroupCodes: string[]): Promise<void> {
    try {
      const service = DomainRegistry.authentication.getAuthenticationService();
      this.isAuthenticating = true;
      this.isAuthenticatingAutomatically = true;
      await service.loginAutomatically(id, departmentId, hostName, orderUserId, attendingUserId, departmentGroupCode, referenceableDepartmentGroupCodes);
      // TODO: できればAuthのAPIにまとめたい
      await this.setUserSelection();
      this.isAuthenticating = false;
      this.isAuthenticatingAutomatically = false;
      this.isAuthenticatedAutomatically = true;
    } catch (e) {
      this.isAuthenticating = false;
      this.isAuthenticatingAutomatically = false;
      throw e;
    }
  }
  
  private async setUserSelection(): Promise<void> {
    this.$logger.info("ユーザ選択保持情報を取得します。");
    try {
      const repo = DomainRegistry.user.getUserSelectionRepository();
      const userSelection = await repo.getUserSelection();
      this.$store.commit("setUserSelection", userSelection);
      console.debug(this.$store.getters.userSelection);
      this.$logger.info("ユーザ選択保持情報を取得しました。");
    } catch (e) {
      this.$logger.warn("ユーザ選択保持情報の取得に失敗しました。");
      this.$logger.warn(e);
    }
  }

  async authenticateBy(id: string, password: string): Promise<void> {
    try {
      this.isAuthenticating = true;
      if (this.doAuthenticate) {
        await this.doAuthenticate(id, password);
      } else {
        await DomainRegistry.authentication.getAuthenticationService().authenticate(id, password);
      }
      this.isAuthenticating = false;
    } catch (e) {
      this.isAuthenticating = false;
      throw e;
    }
  }

  toExceptionMessage(exception: any): string {
    return exception && exception.response && exception.response.data && exception.response.data.exceptionMessage
      ? exception.response.data.exceptionMessage.split("{")[0]
      : "";
  }

  async getDepartmentGroup(departmentGroupCode: string): Promise<DepartmentGroup> {
    if (!departmentGroupCode) { return null; }
    const repo = DomainRegistry.department.getDepartmentRepository();
    return repo.getDepartmentGroup(departmentGroupCode);
  }

  async getDepartmentRelatedDepartmentGroup(department: Department): Promise<DepartmentGroup> {
    if (!department) { return null; }
    const repo = DomainRegistry.department.getDepartmentRepository();
    const departmentGroups = await repo.getDepartmentGroups();
    return Enumerable.from(departmentGroups)
      .where(g => !g.isDeleted && g.departments.some(d => d.id === department.id))
      .firstOrDefault();
  }
}
